import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { categoryName } from "@/lib/api";

export const ProductCard = ({ product, index = 0 }) => {
    const img = product.images?.[0];
    return (
        <Link
            to={`/products/${product.slug}`}
            className="group block"
            data-testid={`product-card-${product.slug}`}
        >
            <div className="product-image-wrap aspect-[4/3]">
                {img ? (
                    <img src={img} alt={product.name} loading="lazy" />
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-gray-400 font-mono text-xs">
                        NO IMAGE
                    </div>
                )}
            </div>
            <div className="pt-5 flex items-start justify-between gap-4">
                <div>
                    <div className="overline text-red-600 mb-2">
                        {String(index + 1).padStart(2, "0")} · {categoryName(product.category)}
                    </div>
                    <h3 className="font-display font-bold text-xl md:text-2xl tracking-tight text-gray-900 group-hover:text-red-600 transition-colors">
                        {product.name}
                    </h3>
                </div>
                <ArrowUpRight className="shrink-0 mt-1 text-gray-400 group-hover:text-red-600 transition-colors" size={22} />
            </div>
            <p className="mt-3 text-sm text-gray-600 leading-relaxed line-clamp-2">{product.summary}</p>
        </Link>
    );
};
